import { BridgeComponent } from "@hotwired/hotwire-native-bridge"
import { BridgeElement } from "@hotwired/hotwire-native-bridge"

/**
 * This is a customized version of @joemasilotti/bridge-components's menu controller which
 * adds our "navigationLink" and "avatarUrl" targets.
 *
 * You can find the original controller in:
 * https://github.com/joemasilotti/bridge-components/blob/main/app/javascript/controllers/bridge/menu_controller.js
 */
export default class extends BridgeComponent {
  static component = "menu"
  static targets = ["item", "navigationLink"]
  static values = {
    avatarUrl: String
  }

  connect() {
    super.connect()
    this.#addMenuButton()
  }

  disconnect() {
    super.disconnect()
    this.#removeMenuButton()
  }

  #addMenuButton() {
    const items = this.itemTargets.map(target => {
      const element = new BridgeElement(target)
      return {
        title: element.title,
        iosImage: element.bridgeAttribute("ios-image"),
        androidImage: element.bridgeAttribute("android-image"),
        destructive: element.bridgeAttribute("destructive") == "true"
      }
    })

    let navigationLink = null
    if (this.hasNavigationLinkTarget) {
      navigationLink = this.navigationLinkTarget.dataset.link
    }

    const color = this.bridgeElement.bridgeAttribute("color")
    this.send("connect", { items, color, navigationLink, avatarUrl: this.avatarUrlValue }, message => {
      const item = this.itemTargets[message.data.index]
      new BridgeElement(item).click()
    })
  }

  #removeMenuButton() {
    this.send("disconnect")
  }
}